import { useCases } from "../../utils/constants";
import { UseCase, UseCaseProps } from "../../utils/interfaces";

const UseCaseCards = ({ selectUseCase }: UseCaseProps) => {
	return (
		<div className="row g-4 mb-4">
			{useCases.slice(0, 5).map((useCase: UseCase, key) => (
				<div className="col" key={`case_cards_${key}`}>
					<div
						className="card h-100 d-flex flex-column"
						onClick={() => selectUseCase(useCase?.value)}
						style={{ 
							cursor: "pointer", 
							// background: "#26397E",
							// color: 'white', 
							// borderTopLeftRadius: "30px",
							// borderTopRightRadius: "0px",
							// borderBottomRightRadius: "30px",
							// borderBottomLeftRadius: "30px",
							transition: "transform 0.2s ease-in-out" }}
					>
						<div className="card-body d-flex flex-column">
							<div className="iconbox mb-3">{useCase?.sprite}</div>
							<div className="d-flex flex-column justify-content-center flex-grow-1">
								<h5 className="card-title mb-3 pt-3">{useCase.name}</h5>
							</div>
							<div className="d-flex flex-column justify-content-end align-items-start flex-grow-1">
								<p className="card-text pb-3">
									{useCase.helpingText}
								</p>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default UseCaseCards;